// Core
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';

// Components
import RequestLogDetailsContent from './components/UserPurchasesDetailsContent';

const UserPurchasesDetails = () => {
  const { id } = useParams();

  const { data: posTransaction, isLoading, isError } = useQuery({
    queryKey: ['user-purchase', id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      return (await apiService.getUserPurchase({ id })).data;
    },
  });


  return (isError ?
    <div>Not Found</div> : isLoading ?
    <div>Loading...</div> :
        <RequestLogDetailsContent posTransaction={posTransaction} />
  );
};

export default UserPurchasesDetails;